var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      directives: [
        {
          name: "resize",
          rawName: "v-resize",
          value: _vm.onResize,
          expression: "onResize"
        }
      ],
      staticClass: "data-table-layout",
      attrs: { column: "" }
    },
    [
      _c(
        "v-data-table",
        {
          staticClass: "elevation-1",
          class: { mobile: _vm.isMobile },
          attrs: {
            id: "main-table",
            "item-key": "id",
            headers: _vm.headers,
            "hide-headers": _vm.isMobile,
            items: _vm.customerFoundtList,
            "disable-initial-sort": true,
            "must-sort": true,
            "rows-per-page-items": [5, 10, 25],
            "pagination-sync": _vm.pagination,
            "total-items": _vm.pagination.totalItems,
            loading: _vm.loading
          },
          on: { "update:pagination": _vm.checkImplementationStatus },
          scopedSlots: _vm._u([
            {
              key: "items",
              fn: function(props) {
                return [
                  !_vm.isMobile
                    ? _c(
                        "tr",
                        {
                          key: props.item.id,
                          class: {
                            rowSelectedBackground:
                              _vm.selectedCustomerId === props.item.id
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.submitForm(props)
                            }
                          }
                        },
                        [
                          _c("td", [_vm._v(_vm._s(props.item.anspName))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(props.item.anspZusatztext))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(props.item.adrePlz))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(props.item.adreOrt))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(props.item.adreStrasse))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(props.item.adreLand))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(props.item.anspTelPrivat))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(props.item.anspTelGesch))]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(_vm._s(props.item.anspTelAlternativ))
                          ]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(props.item.anspMobil))])
                        ]
                      )
                    : _c(
                        "v-card",
                        {
                          staticClass: "responsive-card",
                          staticStyle: { margin: "16px" }
                        },
                        [
                          _c(
                            "tr",
                            {
                              staticClass: "responsive-row",
                              class: {
                                rowSelectedBackground:
                                  _vm.selectedCustomerId === props.item.id
                              },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  $event.preventDefault()
                                  return _vm.submitForm(props)
                                }
                              }
                            },
                            [
                              _c("td", [
                                _c("ul", { staticClass: "flex-content" }, [
                                  _c(
                                    "li",
                                    {
                                      staticClass: "flex-item",
                                      attrs: { "data-label": "Nachname" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(props.item.anspName) +
                                          "\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    {
                                      staticClass: "flex-item",
                                      attrs: { "data-label": "Zusatztext" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(props.item.anspZusatztext) +
                                          "\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    {
                                      staticClass: "flex-item",
                                      attrs: { "data-label": "Postleitzahl" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(props.item.adrePlz) +
                                          "\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    {
                                      staticClass: "flex-item",
                                      attrs: { "data-label": "Ort" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(props.item.adreOrt) +
                                          "\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    {
                                      staticClass: "flex-item",
                                      attrs: { "data-label": "Straße" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(props.item.adreStrasse) +
                                          "\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    {
                                      staticClass: "flex-item",
                                      attrs: { "data-label": "Land" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(props.item.adreLand) +
                                          "\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    {
                                      staticClass: "flex-item",
                                      attrs: { "data-label": "Telefon privat" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(props.item.anspTelPrivat) +
                                          "\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    {
                                      staticClass: "flex-item",
                                      attrs: {
                                        "data-label": "Telefon geschäftlich"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(props.item.anspTelGesch) +
                                          "\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    {
                                      staticClass: "flex-item",
                                      attrs: {
                                        "data-label": "Telefon alternativ"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(props.item.anspTelAlternativ) +
                                          "\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    {
                                      staticClass: "flex-item",
                                      attrs: { "data-label": "Telefon mobil" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(props.item.anspMobil) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                ])
                              ])
                            ]
                          )
                        ]
                      )
                ]
              }
            }
          ]),
          model: {
            value: _vm.selected,
            callback: function($$v) {
              _vm.selected = $$v
            },
            expression: "selected"
          }
        },
        [
          _vm._v(" "),
          _c("template", { slot: "no-data" }, [
            _c(
              "div",
              {
                staticStyle: { "text-align": "center" },
                attrs: { id: "table-empty" }
              },
              [_vm._v("\n        Keine Daten vorhanden\n      ")]
            )
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }